// extracted by mini-css-extract-plugin
module.exports = {"primary":"#00c4b4","white":"#fff"};